import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable,EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class RouteTrackingService {
	public appParcelsServerSideRefresh$: EventEmitter<void>;
	public showMessage$: BehaviorSubject<boolean>;

	constructor(private _http: HttpClient) {
		this.appParcelsServerSideRefresh$ = new EventEmitter<void>();
		this.showMessage$ = new BehaviorSubject<boolean>(false);
	}

	/**
	 * @api {get} /v2/RouteStops/${id}/Receipt Get Receipt
	 * @apiName getReceipt
	 * @apiGroup RouteStops
	 * @apiVersion 20.0.0
	 */
	getReceipt(id) {
		return this._http.get<any>(`${environment.apiUrl}/v2/RouteStops/${id}/Receipt`);
	}

	/**
	 * @api {get} /v2/Routes/PostDates Get Route Post Dates
	 * @apiName getRoutePostDates
	 * @apiParam {string} [dateFrom] Date From
	 * @apiGroup Routes
	 * @apiVersion 20.0.0
	 */
	getRoutePostDates(date) {
		let params: HttpParams = new HttpParams();
		params = params.append('dateFrom', date);
		return this._http.get<any>(`${environment.apiUrl}/v2/Routes/PostDates`, {params});
	}

	/**
	 * @api {get} /v2/RouteTracking/:id Get Route Stop Detail
	 * @apiName getRouteStopDetail
	 * @apiParam {boolean} [includeParcels] Include Parcels
	 * @apiParam {boolean} [includeStatusCodes] Include Status Codes
	 * @apiParam {boolean} [includeSignature] Include Signature
	 * @apiParam {boolean} [includeAttachments] Include Attachments
	 * @apiParam {boolean} [includeParcelAssignmentItems] Include Parcel Assignment Items
	 * @apiGroup RouteStops
	 * @apiVersion 20.0.0
	 */
	getRouteStopDetail(id, includeParcels, includeStatusCodes, includeSignature) {
		let params: HttpParams = new HttpParams();
		params = params.append('includeParcels', includeParcels);
		params = params.append('includeStatusCodes', includeStatusCodes);
		params = params.append('includeSignature', includeSignature);
		params = params.append('includeAttachments', 'true');
		params = params.append('includeParcelAssignmentItems', 'true');
		return this._http.get<any>(`${environment.apiUrl}/v2/RouteTracking/${id}`, {params});
	}

	/**
	 * @api {get} /v2/RouteStops/${id}/${postDate} Get Route Stops
	 * @apiName getRouteStops
	 * @apiGroup RouteStops
	 * @apiVersion 20.0.0
	 */
	getRouteStops(id, postDate) {
		return this._http.get<any>(`${environment.apiUrl}/v2/RouteStops/${id}/${postDate}`);
	}

	/**
	 * @api {post} /v2/RouteStops/Summary/:postDate Get Route Tracking Summary
	 * @apiName getRouteTrackingSummary
	 * @apiParam {number} [pageNum] Page Number
	 * @apiParam {number} [pageSize] Page Size
	 * @apiParam {string} [sortColumn] Sort Column
	 * @apiParam {string} [sortDirection] Sort Direction
	 * @apiGroup RouteStops
	 * @apiVersion 20.0.0
	 */
	getRouteTrackingSummary(postDate, page, size, search, sort, dir) {
		let params: HttpParams = new HttpParams();
		params = params.append('pageNum', page);
		params = params.append('pageSize', size);
		if (sort) {
			params = params.append('sortColumn', sort);
		}
		if (dir) {
			params = params.append('sortDirection', dir);
		}
		return this._http.post<any>(`${environment.apiUrl}/v2/RouteStops/Summary/${postDate}`, JSON.stringify(search), {params});
	}

	/**
	 * @api {put} /v2/RouteStops/:id/StatusEvent Update Route Stop
	 * @apiName getRouteStops
	 * @apiGroup RouteStops
	 * @apiVersion 20.0.0
	 */
	updateRouteStop(id, date, pod, action, rowVersion) {
		const data = {
			occurredAt: date,
			statusEvent: action,
			pod,
			rowVersion
		};
		return this._http.put<any>(`${environment.apiUrl}/v2/RouteStops/${id}/StatusEvent`, data);
	}
   /**
   * @api {get} v2/RouteTracking/{stopId}/Parcels get parcels by route stop id
   * @apiName getParcelsByStopId
   * @apiGroup RouteStops
   * @apiVersion 20.0.0
   */
     getParcelsByStopId(stopId, filter, pageNum, pageSize) {
      return this._http.get<any>(`${environment.apiUrl}/v2/RouteTracking/${stopId}/Parcels?filter=${filter || ''}&pageNum=${pageNum}&pageSize=${pageSize}`);
    }
}
